export * from "./DeceasedDetailsPageHeader";
export * from "./DeceasedDetailsBody";
